'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideMenu = undefined;

require('font-awesome/css/font-awesome.css');

require('./style.css');

var _SideMenu = require('./components/SideMenu');

var _SideMenu2 = _interopRequireDefault(_SideMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SideMenu = _SideMenu2.default;
exports.default = {
  SideMenu: _SideMenu2.default
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/xe-ui-kit/lib/index.js
 ** module id = 1978
 ** module chunks = 73
 **/